import { Check, Clock, Eye, X } from "react-feather";
import styles from "./tenantjourney.module.css";
import { Dialog, DialogContent, Tooltip, Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { useState } from "react";
import dayjs from "dayjs";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { useAuth0 } from "@auth0/auth0-react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const TenantJourney = ({ tenantData, setLoading, expanded, handleChange }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [docUrl, setDocUrl] = useState("");
  const [openDocModal, setOpenDocModal] = useState(false);

  const viewDocumnets = async (item) => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    axios.get(process.env.REACT_APP_TENANT_API_URL + "v1/get-tenant-document/" + item?.foreign_id, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);
      setOpenDocModal(true);
      setDocUrl(response.data.data?.file_url);
    }).catch((error) => {
      setLoading(false);
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
    });
  }

  return (<Accordion expanded={expanded === "panel2"} onChange={handleChange("panel2")}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
      <div className={`${styles.FormAccoHead}`}>
        <p className={`${styles.FormAccoHeadTitlePro}`}>Tenant Journey</p>
      </div>
    </AccordionSummary>
    <AccordionDetails>
      <div className={`${styles.cardUnderS}`}>
        <div className={`${styles.cardUnderSHead}`}>
          <div className={`${styles.HeadIcon}`}>
            <img src="/static/img/tenant-journey.png" alt="" />
          </div>
          <div className={`${styles.HeadCon}`}>
            <p className={`${styles.HeadConTitle}`}>Tenant Journey</p>
            <p className={`${styles.HeadConText}`}>Tenant Since{" "}{dayjs(tenantData?.journey[0]?.submitted_at).format("MMM D, YYYY")}</p>
          </div>
        </div>
        <div className={`${styles.cardUnderSBody}`}>
          <ul>
            {tenantData?.journey?.map((item) => {
              let className = "";
              if (item?.status === 1) {
                className = `${styles.Completed}`;
              } else if (item?.status === 2) {
                className = `${styles.Failed}`;
              } else {
                className = `${styles.Ongoing}`;
              }
              return (<li key={item.id} className={className}>
                {item?.status === 1 && (<Tooltip title="Completed">
                  <span><Check /></span>
                </Tooltip>)}
                {item?.status === 0 && (<Tooltip title="Ongoing">
                  <span><Clock /></span>
                </Tooltip>)}
                {item?.status === 2 && (<Tooltip title="Failed">
                  <span>!</span>
                </Tooltip>)}
                <div>
                  {item?.status === 1 && item?.type === "id-verify" ? (<button onClick={(e) => viewDocumnets(item)}>{item?.description} <Eye /></button>) : (<p>{item?.description}</p>)}
                  <p className={`${styles.Date}`}>{dayjs(item?.submitted_at).format("MMMM D, YYYY")}</p>
                </div>
              </li>);
            })}
          </ul>
        </div>
      </div>

      <Dialog
        onClose={(e) => { setOpenDocModal(false); setDocUrl(""); }}
        aria-labelledby="customized-dialog-title"
        open={openDocModal}
        className="NewPopUp NewPopUpForLease"
      >
        <button onClick={(e) => { setOpenDocModal(false); setDocUrl(""); }} className={`${styles.IDImageCloseBU}`}><X /></button>
        <DialogContent>
          <div className={`${styles.IDImageSec}`}>
            <img src={docUrl} className={`${styles.IDImage}`} alt="" />
          </div>
        </DialogContent>
      </Dialog>
    </AccordionDetails>
  </Accordion>);
};

export default TenantJourney;